import { render, staticRenderFns } from "./SearchForum.vue?vue&type=template&id=16666eba&scoped=true"
import script from "./SearchForum.vue?vue&type=script&lang=js"
export * from "./SearchForum.vue?vue&type=script&lang=js"
import style0 from "./SearchForum.vue?vue&type=style&index=0&id=16666eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16666eba",
  null
  
)

export default component.exports